export default "__VITE_ASSET__ad09f0ec__"